'use strict'

const BULK_MATCH_PREVIEW_LIMIT = 100

function bulkMatchPreview (rows, limit) {

  const list = Array.isArray(rows) ? rows : []
  const cap = Number.isInteger(limit) && limit > 0 ? limit : BULK_MATCH_PREVIEW_LIMIT

  return {
    count: list.length,
    rows: list.slice(0, cap)
  }
}

module.exports = {
  BULK_MATCH_PREVIEW_LIMIT,
  bulkMatchPreview
}
